import React,{useState, useEffect} from 'react';
import { getFuturesAccountInfo } from '../services/futuresWallet';
import { Line } from 'react-chartjs-2';

const FutureBalanceChart = () => {
    const [balanceData, setBalanceData] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBalanceData = async () => {
            try {
              const data = await getFuturesAccountInfo();
              setBalanceData(data);
              
            } catch (err) {
              setError('Failed to fetch futures balance. Please try again later.');
            }
          };
      
          fetchBalanceData();
    }, [])
    
  return (
    <div>
        <ul>
            {balanceData?.data?.totalWalletBalance}
            {/* {balanceData.map((asset) => (
                <li>
                    {asset.walletBalance}
                    <br />
                    {asset.asset}
                </li>
            ))} */}
        </ul>
    </div>
  )
}

export default FutureBalanceChart